import { FC } from 'react';

import { GridColumn, GridLayout, GridRow, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import { AdminPageContentHeader } from 'components/Admin/AdminPageContentHeader/AdminPageContentHeader';
import { UserDetail } from 'components/Admin/UserDetail/UserDetail';

const TrlKeys = {
    title: 'admin.UserDetail.title',
};

export const UserDetailPage: FC = () => {
    const trls = useTrls();

    return (
        <>
            <AdminHeader />
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={12}>
                        <AdminPageContentHeader title={trls(TrlKeys.title)} />
                        <UserDetail />
                        <VSpacing default={24} />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </>
    );
};
